import dayjs from 'dayjs';
import _ from 'lodash';

import { COMMON_REQUEST_DATE_FORMAT } from 'constants/date';

// Stored the way the extraction form stores dates (YYYY-MM-DD); a cleared or invalid date is empty.
export const toWorksheetDateValue = date =>
  !_.isNil(date) && dayjs(date).isValid() ? dayjs(date).format(COMMON_REQUEST_DATE_FORMAT) : null;
